import axios from "axios";

export const fetchReviews = async (productId, page) => {
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/reviews?product=${productId}&page=${page}`
  );
  return data;
};
